import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { emptyAvatar } from "../../imagepath";
import { getFile } from "../../../lib/file";

export default function InstructorTable({ data }) {
    const { name, surname, id, email, avatar_url, phone, isActive } = data;
    const [avatar, setAvatar] = useState();
    // console.log("data :", data )
    async function GetData() {
        if (avatar_url) {
            const avt = await getFile(avatar_url);
            setAvatar(avt.publicUrl);
        }
    }

    useEffect(() => {
        GetData();
    }, [avatar_url]);

    return (
        <tr key={id}>
            <td>
                <Link to={`/admin/admin-instructordetail/${id}`}>
                    <img
                        className='img-fluid rounded-circle'
                        alt='Students Info'
                        src={avatar ? avatar : emptyAvatar}
                        style={{ width: '50px', height: '50px' }}
                    />
                </Link>
            </td>
            <td>
                <Link to={`/admin/admin-instructordetail/${id}`}>
                    {name + ' ' + surname}
                </Link>
            </td>
            <td>{email}</td>
            <td>{phone}</td>
            <td>
                {isActive ? (
                    <i className='fas fa-circle-check green h3'></i>
                ) : (
                    <i className='fas fa-minus-circle red h3'></i>
                )}
            </td>
        </tr>
    );
}
